import jump from 'jump.js-cancelable'
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'

import bookmarkBind from 'bookmarks/bind'
import { bind as googleMapsBind } from '../google_maps'

import jobListBinding from '../job_list/bind'

import { LEFT_KEYCODE, RIGHT_KEYCODE } from 'util/keycodes'

export default class JobList {
  constructor ($el, eventNameSpace) {
    this.$el = $el
    this.$sidebar = this.$el.find('.js-job-list-sidebar')
    this.$content = this.$el.find('.js-job-list-content')
    this.$jobOutlet = this.$el.find('.js-job-list-job-outlet')
    this.$jobSkeleton = this.$jobOutlet.html()
    this.url = this.$el.data('load-url')
    this.jobUrl = (jobId) => this.$el.data('job-url').replace(':id', jobId)
    this.tags = new Set()
    this.searchTerms = new Set()
    this.eventNameSpace = eventNameSpace
    this.debouncedLoadJobs = this.debounce(this.loadJobs.bind(this), 300)
    this.debouncedLoadJob = this.debounce(($job) => { this.loadJob($job, false, false) }, 300)
    this.xhrCount = 0
    this.sort = null

    this.addEventHandlers()
    this.loadFirstJob()
  }

  debounce (fn, delay) {
    var timer = null
    return function () {
      var context = this
      var args = arguments
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(context, args)
      }, delay)
    }
  }

  addEventHandlers () {
    EventBus.on(`${this.eventNameSpace}:add`, this.onAdd.bind(this))
    EventBus.on(`${this.eventNameSpace}:remove`, this.onRemove.bind(this))
    EventBus.on(`${this.eventNameSpace}:new_profile`, this.onNewProfile.bind(this))
    EventBus.on(`${this.eventNameSpace}:sort`, this.onSort.bind(this))
    EventBus.on(`${this.eventNameSpace}:setup-complete`, () => {
      EventBus.on(`${this.eventNameSpace}:add ${this.eventNameSpace}:remove ${this.eventNameSpace}:sort`, this.debouncedLoadJobs)
    })

    this.$el.on('click', '.js-job-list-item', this.onJobClick.bind(this))

    $(window).on('keyup', this.onKeypress.bind(this))
    $(window).on('popstate', this.onPopState.bind(this))
  }

  onKeypress (event) {
    if (this.isJobPreview() && !$(event.originalEvent.srcElement).is('input[type="text"], textarea')) {
      if (event.keyCode === RIGHT_KEYCODE) {
        this.loadNextJob(this.$content.find('.result__list-item--active'))
      }

      if (event.keyCode === LEFT_KEYCODE) {
        this.loadPrevJob(this.$content.find('.result__list-item--active'))
      }
    }
  }

  onAdd (_event, data) {
    if (data.type === 'search-term') {
      this.searchTerms.add(data.key)
    } else {
      this.tags.add(data.key)
    }
  }

  isJobPreview () {
    return MediaQuery.current === 'large'
  }

  onJobClick (event) {
    // only handle events whose default has not yet been prevented (as is the case for bookmarking)
    // ../bookmarks/bookmark_add.js, // ../bookmarks/bookmark_remove.js
    if (this.isJobPreview() && !event.isDefaultPrevented() && !event.metaKey && !event.ctrlKey) {
      event.preventDefault()
      this.changeJob($(event.currentTarget))
    }
  }

  onNewProfile (_event, data) {
    this.tags = new Set(data.tags.map(tag => tag.key))
    this.searchTerms = new Set(data.searchTerms.map(term => term.key))
  }

  onRemove (_event, data) {
    this.searchTerms.delete(data.key)
    this.tags.delete(data.key)
  }

  onPopState (event) {
    window.location.reload()
  }

  onSort (_event, newSort) {
    this.sort = newSort
  }

  loadFirstJob () {
    if (this.isJobPreview()) {
      const $firstJob = this.$content.find('.js-job-list-item').first()
      if ($firstJob.length > 0) {
        this.loadJob($firstJob, true)
      } else {
        this.$jobOutlet.empty()
      }
    }
  }

  loadNextJob ($active) {
    const $next = $active.nextAll('.js-job-list-item:first')
    if ($next.length) {
      this.changeJob($next)
    } else {
      const $nextListFirst = $active.parent().next('.result__list').children('.js-job-list-item:first')
      if ($nextListFirst.length) {
        this.changeJob($nextListFirst)
      }
    }
  }

  loadPrevJob ($active) {
    const $prev = $active.prevAll('.js-job-list-item:first')
    if ($prev.length) {
      this.changeJob($prev)
    } else {
      const $prevListLast = $active.parent().prev('.result__list').children('.js-job-list-item:last')
      if ($prevListLast.length) {
        this.changeJob($prevListLast)
      }
    }
  }

  changeJob ($job) {
    this.showJobChangeIntent($job)
    this.debouncedLoadJob($job)
  }

  loadJob ($job, initial = false, showJobChangeIntent = true) {
    const jobId = $job.data('job-id')
    if (showJobChangeIntent) { this.showJobChangeIntent($job) }

    if (this.loadJobRequest) {
      this.loadJobRequest.abort()
    }

    this.loadJobRequest = $.ajax({
      method: 'GET',
      url: this.jobUrl(jobId),
      data: {
        initial: initial
      },
      dataType: 'json'
    }).done((response) => {
      this.$jobOutlet.html(response.body)
      googleMapsBind(this.$jobOutlet)
      bookmarkBind(this.$jobOutlet)
      EventBus.trigger('tracking:pageload', response.webtrekk)
      EventBus.trigger('bookmarks:replay', null)
      EventBus.trigger('vue:mount', null)
    })
  }

  loadJobs () {
    this.$content.fadeOut()
    this.$sidebar.fadeOut()
    this.$jobOutlet.html(this.$jobSkeleton)
    const seqNumber = ++this.xhrCount
    $.ajax({
      method: 'GET',
      url: this.url,
      data: {
        category_tags: [...this.tags],
        q: [...this.searchTerms].join(','),
        sort: this.sort
      },
      dataType: 'json'
    }).done((response) => {
      if (seqNumber !== this.xhrCount) {
        return
      }

      history.pushState({}, '', response.url)
      this.updateMeta(response.meta.meta_tags)
      EventBus.trigger(`${this.eventNameSpace}:headline`, response.headline)
      EventBus.trigger(`${this.eventNameSpace}:results-count`, response.count)
      this.handleNewProfile(response.profile)
      this.$content.html(response.body)
      this.$sidebar.html(response.sidebar)
      bookmarkBind(this.$el)
      EventBus.trigger('bookmarks:replay', null)
      EventBus.trigger('tracking:pageload', response.webtrekk)
      EventBus.trigger('vue:mount', null)
      this.loadFirstJob()
      this.$content.fadeIn()
      this.$content.scrollTop(0)
      this.$sidebar.fadeIn()
      jobListBinding()
      this.triggerSnackbar(response.snackbar)
    })
  }

  showJobChangeIntent ($job) {
    this.$content.find('.js-job-list-item').removeClass('result__list-item--active')
    $job.addClass('result__list-item--active')
    if ($job.get(0).scrollIntoView) {
      $job.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    }
    this.$jobOutlet.html(this.$jobSkeleton)
  }

  handleNewProfile (profile) {
    const searchTerms = this.nonEmptyTerms(profile.search_terms).map(term => ({
      label: term,
      key: '' + term,
      type: 'search-term'
    }))

    EventBus.trigger(`${this.eventNameSpace}:new_profile`, {
      searchTerms,
      tags: profile.tags
    })
  }

  nonEmptyTerms (terms) {
    return terms.split(',').filter(term => term !== '')
  }

  updateMeta (metaTags) {
    document.title = metaTags.title
    $('meta[name="description"]').attr('content', metaTags.description)
    $('meta[name="robots"]').attr('content', metaTags.robots)
  }

  onGotoResults (event) {
    event.preventDefault()
    EventBus.trigger('snackbar:hide', null)
    jump.jump(this.$el.get(0), {
      duration: distance => Math.max(Math.abs(distance), 500)
    })
  }

  onSnackbarClose (event) {
    event.preventDefault()
    EventBus.trigger('snackbar:hide', null)
  }

  triggerSnackbar (content) {
    EventBus.trigger('snackbar:hide', null)
    if (!this.isElementInViewport()) {
      EventBus.trigger('snackbar:message', {
        small: true,
        body: content,
        handlers: [
          { eventName: 'click', selector: '.js-snackbar__button', handler: this.onGotoResults.bind(this) },
          { eventName: 'click', selector: '.js-snackbar__close', handler: this.onSnackbarClose.bind(this) }
        ]
      })
    }
  }

  isElementInViewport () {
    const elem = this.$el.find('.post__item-published').get(0)

    if (!elem) {
      return true
    }
    const rect = elem.getBoundingClientRect()

    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}
